import Vue from "vue";
class TeamService {
  GetGrid(page, term) {
    return Vue.prototype.$http({
      url: "/team/get-grid/" + page + "/20?term=" + encodeURIComponent(term || ""),
      method: "GET"
    });
  }

  Get(id) {
    return Vue.prototype.$http({
      url: "/team/get/" + id,
      method: "GET"
    });
  }

  GetVSelect(term) {
    return Vue.prototype.$http({
      url: "/team/get-v-select?term=" + encodeURIComponent(term || ""),
      method: "GET"
    });
  }

  New(viewModel) {
    return Vue.prototype.$http({
      url: "/team/new",
      data: viewModel,
      method: "POST"
    });
  }

  Edit(viewModel) {
    return Vue.prototype.$http({
      url: "/team/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  Remove(id) {
    return Vue.prototype.$http({
      url: "/team/remove/" + id,
      method: "DELETE"
    });
  }
}

export default new TeamService();
